module.exports = __webpack_public_path__ + "img/smartphone-ptt.e1b8272f.webp";